// function collectionAjax(load_more_btn) {
//     if (load_more_btn) {
//         load_more_btn.addEventListener('click', function (e) {
//             e.preventDefault();
//             let $this = this;
//             if ($this.classList.contains("active")) {
//                 return false;
//             }
//             $this.classList.add('active');
//             let section = document.querySelector('ul#product-grid');
//             let collections = document.querySelector('.collection-hero__inner .collections');
//             let loader = document.querySelector('.apply-changes .lds-ring');
//             document.querySelector('.apply-changes span').style.opacity = "70%";
//             section.classList.add('loading');
//             if (collections) {
//                 collections.classList.add('loading');
//             }
//             loader.classList.remove('hidden');
//             let link = this.href;
//             let isPartFinder = document.querySelector(".sp-collection-part-finder");
//             if (isPartFinder) {
//                 isPartFinder.classList.add('loading');
//                 if (link.indexOf("view=part-finder") === -1) {
//                     if (link.indexOf("?") === -1) {
//                         link = link + "?view=part-finder"
//                     } else {
//                         link = link + "&view=part-finder"
//                     }
//                 }
//             } else {
//                 if (link.indexOf("view=new-collection") != -1) {
//                     link = link.replace('?view=new-collection', '')
//                     link = link.replace('&view=new-collection', '')
//                 }
//                 if (link.indexOf("view=ajax") === -1) {
//                     if (link.indexOf("?") === -1) {
//                         link = link + "?view=ajax"
//                     } else {
//                         link = link + "&view=ajax"
//                     }
//                 }
//             }

//             fetch(link)
//                 .then((response) => response.text())
//                 .then((responseText) => {
//                     const html = responseText;
//                     const parser = new DOMParser();
//                     let newDOM = parser.parseFromString(html, "text/html");
//                     const queryString = window.location.search;
//                     const urlParams = new URLSearchParams(queryString);
//                     let par = urlParams.get('discount')
//                     let stateObj = { parameter: par }
//                     if (link.indexOf("view=ajax") != -1) {
//                         link = link.replace('&view=ajax', '')
//                         link = link.replace('?view=ajax', '')
//                     }

//                     let storeurl = new URL(link, window.location.origin);

//                     // Remove `view=ajax` if present
//                     if (storeurl.searchParams.get('view') === 'ajax') {
//                         storeurl.searchParams.delete('view');
//                     }

//                     // Always keep view=new-collection if banner exists
//                     if (document.querySelector(".sp-collection-banner")) {
//                         storeurl.searchParams.set('view', 'new-collection');
//                     }

//                     // Keep discount if it was in the current page's params
//                     let currentParams = new URLSearchParams(window.location.search);
//                     if (currentParams.has('discount')) {
//                         storeurl.searchParams.set('discount', currentParams.get('discount'));
//                     }

//                     // Update the browser's URL without reloading
//                     window.history.replaceState(stateObj, '', storeurl.toString());
//                     loader.classList.add('hidden');
//                     document.querySelector('.apply-changes span').style.opacity = "100%";
//                     const newGrid = newDOM.querySelector('ul#product-grid');
//                     if (load_more_btn.classList.contains('previous')) {
//                         const newItems = newDOM.querySelectorAll('ul#product-grid > li.grid__item');
//                         newItems.forEach(item => {
//                             section.insertBefore(item, section.firstChild);
//                         });
//                     } else {
//                         section.insertAdjacentHTML('beforeend', newGrid.innerHTML);
//                     }
//                     let pagination = newDOM.querySelector('.pagination-list-wrapper').innerHTML;
//                     let previousPage = document.querySelector('.pagination-list-wrapper-previous');
//                     if (pagination.trim() != '') {
//                         if (newDOM.getElementById("load-more-collections-btn") && !load_more_btn.classList.contains('previous')) {
//                             load_more_btn.href = newDOM.getElementById("load-more-collections-btn").href;
//                         }
//                         if (newDOM.getElementById("load-previous-collections-btn")) {
//                             if (load_more_btn.classList.contains('previous')) {
//                                 load_more_btn.href = newDOM.getElementById("load-previous-collections-btn").href;
//                             }
//                         } else {
//                             if (previousPage) {
//                                 previousPage.style.display = 'none';
//                             }
//                         }
//                         let back_to_top = newDOM.getElementById('back-to-top');
//                         if (back_to_top) {
//                             load_more_btn.remove();
//                             document.querySelector('.pagination-list-wrapper').innerHTML = pagination;
//                             back_to_top = document.getElementById('back-to-top');
//                             back_to_top.style.display = '';
//                             back_to_top.addEventListener("click", () => {
//                                 window.scrollTo({
//                                     top: 0,
//                                     behavior: "smooth"
//                                 });
//                             });
//                         }
//                     } else {
//                         load_more_btn.remove();
//                     }
//                     document.dispatchEvent(
//                         new CustomEvent("ajaxSearchComplete", {
//                             bubbles: true,
//                             detail: {},
//                         }),
//                     );
//                     preventHyperLinking();
//                     let number_of_products = document.querySelectorAll("[data-productcount]");
//                     let number_of_products_newdom = newDOM.querySelector("[data-productcount]");
//                     if (number_of_products.length > 0) {
//                         let base_count = number_of_products[0].innerHTML;
//                         number_of_products.forEach(function (element, index) {
//                             if (number_of_products_newdom) {
//                                 element.innerHTML = parseInt(base_count) + parseInt(number_of_products_newdom.dataset.count);
//                             }
//                         })
//                     }
//                     document.querySelectorAll('#product-grid .grid__item .product__card').forEach((card) => {
//                         if (!card.querySelector(".discounted")) {
//                             applyDiscountCode(card)
//                         }

//                     });
//                     section.classList.remove('loading');
//                     const animatedElements = document.querySelectorAll('.fade-in-animation');
//                     animatedElements.forEach(element => {
//                         element.classList.add('visible');
//                     });
//                     if (collections) {
//                         collections.classList.remove('loading');
//                     }
//                     $this.classList.remove('active');
//                     if (isPartFinder) {
//                         isPartFinder.classList.remove('loading');
//                     }
//                 });
//         })
//     }
// }

document.addEventListener("DOMContentLoaded", function () {
    // let load_more_btn = document.getElementById("load-more-collections-btn");
    // if (load_more_btn) {
    //     collectionAjax(load_more_btn)
    // }
    // let load_previous_btn = document.getElementById("load-previous-collections-btn");
    // if (load_previous_btn) {
    //     collectionAjax(load_previous_btn)
    // }
    let checkifData = document.querySelector(".js-collection-filter");
    let stickyWrapper = document.querySelector(".sl-collection__nav + .sl-collection__header");
    if (checkifData && checkifData?.innerHTML == '') {
        checkifData.parentElement.classList.add('d-none');
        stickyWrapper?.classList.add('nofilter')
    }

    document.addEventListener('click', function (e) {
        const addCartBtn = e.target.closest('.sl-product-card__add-cart');
        if (addCartBtn) {
            // 🛑 Stop navigation and bubbling up to the <a>
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        const item = e.target.closest('#sl-collection__items .sl-collection__items-col .js-product-card');
        if (!item) return;

        const itemTop = item.getBoundingClientRect().top;
        
        sessionStorage.setItem('collectionScrollItem', JSON.stringify({
            selector: item.dataset.id,
            topOffset: itemTop
        }));
    });

    const saved = sessionStorage.getItem('collectionScrollItem');

    setTimeout(() => {
        if (saved) {
            const data = JSON.parse(saved);
            let item;
            if (data.selector) {
                item = document.querySelector(`.sl-collection__items-col .js-product-card[data-id="${data.selector}"]`);
            }
            if (item) {
                window.scrollTo({ top: 0, behavior: 'auto' })
                const scrollTo = item.getBoundingClientRect().top - data.topOffset;
                window.scrollTo({ top: scrollTo, behavior: 'smooth' });
            }
            sessionStorage.removeItem('collectionScrollItem');
        }
    }, 2000)
});